import React from 'react';
import {
  GreenFiberIcon,
  RedNotificationsActiveRoundedIcon,
  RedNotificationsActiveIcon,
  GreyNotificationsPausedIcon,
  GreyFiberIcon
} from './styles';

const AlertIcon = ({ iconType, alertStatuses }) => {
  const { currentAlert, pastAlert, confirmedAlerts, noAlert } = alertStatuses;

  switch (iconType) {
    case currentAlert:
      return <RedNotificationsActiveRoundedIcon aria-label={iconType} />;
    case pastAlert:
      return <RedNotificationsActiveIcon aria-label={iconType} />;
    case confirmedAlerts:
      return <GreyNotificationsPausedIcon aria-label={iconType} />;
    case noAlert:
      return <GreenFiberIcon aria-label={iconType} />;
    default:
      return <GreyFiberIcon aria-label={iconType} />;
  }
};

export default AlertIcon;
